export const iconButton = () => ({
    background: 'none',
    border: 'none',
    '-webkit-appearance': 'none',
    padding: 0,
    display: 'flex',
});
